export class LoginSubjectLinksInstalledUsersDTOModel {
  name: string;
  subject_guid: string;
}